import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

/**
 * Lean code_value row (label + optional badge metadata) for a tenant-configurable
 * status set, e.g. STORE_PAYMENT_STATUS / STORE_SHIPPING_STATUS / STORE_COUPON_TYPE.
 */
export interface StorefrontCodeOption {
  code: string;
  name: string;
  metadata?: Record<string, unknown>;
}

/**
 * Contract the storefront library uses to fetch tenant-configurable code_value
 * options (order statuses, coupon types, etc.) without depending on any app's
 * own code-value service. Each app provides an adapter via
 * {@link STOREFRONT_CODE_VALUES} (mirrors STOREFRONT_ACCESS / STOREFRONT_TIMEZONE).
 */
export interface StorefrontCodeValueProvider {
  getOptionsForCategory(category: string): Observable<StorefrontCodeOption[]>;
}

export const STOREFRONT_CODE_VALUES = new InjectionToken<StorefrontCodeValueProvider>(
  'STOREFRONT_CODE_VALUES',
  {
    providedIn: 'root',
    factory: () => ({ getOptionsForCategory: () => of([]) }),
  },
);
